export default {
    bind(el, binding) {
        let isActivated = false;

        // 延迟激活，避免首次点击触发关闭
        setTimeout(() => {
            isActivated = true;
        }, 0);

        el.__ClickOutsideHandler__ = function (event) {
            if (!isActivated) return;
            if (!el.contains(event.target)) {
                binding.value(event);
            }
        };

        document.addEventListener('click', el.__ClickOutsideHandler__);
    },
    unbind(el) {
        document.removeEventListener('click', el.__ClickOutsideHandler__);
        el.__ClickOutsideHandler__ = null;
    }
};
